import { Component, OnInit, QueryList, ViewChildren } from "@angular/core";
import {
  NgbdSortableHeader,
} from "../../../../shared/directives/NgbdSortableHeader";
import { VehiclesService } from "../../../../shared/services/vehicles.service";
import { PropietarioService } from "../../../../shared/services/propietarios.service";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import Swal from "sweetalert2";
import {
  preoperacionales,
  PreoperacionalesService,
} from "../../../../shared/services/preoperacionales.service";
import { Utils } from "../../../../shared/utils/Utils";
import jsPDF from "jspdf";
import * as QRCode from 'qrcode';
import { gpcGoogleService } from "../../../../shared/services/gpcGoogle.service";
import { finalize, firstValueFrom } from "rxjs";
import { text } from "stream/consumers";
import {
  ApexNonAxisChartSeries,
  ApexChart,
  ApexResponsive,
  ApexLegend,
  ApexTitleSubtitle
} from "ng-apexcharts";
import { Administracion } from "../../../../shared/model/administracion.model";
import { AdministracionService } from "../../../../shared/services/administracion.services";
import { AdminSeafLoadingService } from "../../../../shared/services/adminseaf-loading.service"

export function noEspaciosEnBlanco(): ValidatorFn {
  return (control: AbstractControl) => {
    const valor = control.value;
    if (typeof valor === "string" && valor.trim() === "") {
      return { espaciosBlancos: true };
    }
    return null;
  };
}

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  colors?: string[];
  legend?: ApexLegend;
  responsive?: ApexResponsive[];
  title?: ApexTitleSubtitle;
};

@Component({
  selector: "app-alistamientos-diarios",
  templateUrl: "./alistamientos-diarios.component.html",
  styleUrls: ["./alistamientos-diarios.component.scss"],
})
export class AlistamientosDiariosComponent implements OnInit {


  chartOptions!: Partial<ChartOptions>;
  chartSeries: ApexNonAxisChartSeries = [];
  vehiculos!: string[];
  conductor: any;
  formPreoperacionales!: FormGroup;
  formEstado!: FormGroup;
  hoy: string = "";
  minFechaFinal: string = "";
  mostrandoToast = false;
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  tiposVehiculosMotos = [12, 19, 20];

  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;
  resultadosPreoperacionales: any[] = [];
  public activity: any[] = [];
  filteredPreoperacionales: any[] = [];
  mensajeBusqueda!: string;
  mostrarTabla: boolean = false;
  searchText: any;
  pageSize1: number = 10;
  page1: number = 1;
  totalItems!: number;
  estadoPreoperacional: any[] = [];
  tabActivo: number = 1; // o el tab que quieras mostrar por defecto
  resultadoPreo: any;
  filteredTableItems: any[] = [];

  administraciones: Administracion[] = [];
  altura: number = 0;
  ancho: number = 0;
  posicionX: number = 0;
  posicionY: number = 0;
  incluirParticulares: number = 0;
  isPermitidoMotos: boolean = false;
  isParticulares: boolean = false;
  constructor(
    private vehiclesService: VehiclesService,
    private propietariosService: PropietarioService,
    private preoperacionalesService: PreoperacionalesService,
    private fb: FormBuilder,
    private gpcGoogle: gpcGoogleService,
    private administracionesServices: AdministracionService,
    private adminSeafLoadingService: AdminSeafLoadingService
  ) { }

  async ngOnInit(): Promise<void> {
    this.adminSeafLoadingService.mostrar(
      'Cargando datos',
      [
        {
          id: 'preparando',
          nombre: 'Cargando datos',
          icono: '📝',
          visible: true,
          estado: 'cargando'
        }
      ],
      'Por favor espere...'
    );

    try {
      this.formPreoperacionales = this.fb.group({
        fecha: [null, Validators.required],
        hora: [null, Validators.required],
        cedula: [null, Validators.required],
        conductor: [null, Validators.required],
        placa: [null, Validators.required],
        transito: [null, Validators.required],
        operacion: [null, Validators.required],
        soat: [null, [Validators.required, noEspaciosEnBlanco()]],
        cda: [null, Validators.required],
        rcc: [null, Validators.required],
        rce: [null, Validators.required],
        licencia: [null, Validators.required],
        kilometraje: [null, Validators.required],
        caja: [null, Validators.required],
        suspension: [null, Validators.required],
        agua: [null, Validators.required],
        fugas: [null, Validators.required],
        correas: [null, Validators.required],
        electricos: [null, Validators.required],
        espejo: [null, Validators.required],
        laterales: [null, Validators.required],
        alarma: [null, Validators.required],
        tapas: [null, Validators.required],
        frenos: [null, Validators.required],
        frenoe: [null, Validators.required],
        cinturon: [null, Validators.required],
        vidrios: [null, Validators.required],
        botiquin: [null, Validators.required],
        extintor: [null, Validators.required],
        asientos: [null, Validators.required],
        tablero: [null, Validators.required],
        estribos: [null, Validators.required],
        baterias: [null, Validators.required],
        altas: [null, Validators.required],
        delanteras: [null, Validators.required],
        traseras: [null, Validators.required],
        estacionarias: [null, Validators.required],
        stop: [null, Validators.required],
        llantas: [null, Validators.required],
        presion: [null, Validators.required],
        repuesto: [null, Validators.required],
        observaciones: [null, Validators.required],
        fechaFinal: [null]
      });

      const hoy = new Date();
      const fechaActual = [
        hoy.getFullYear(),
        String(hoy.getMonth() + 1).padStart(2, '0'),
        String(hoy.getDate()).padStart(2, '0')
      ].join('-');

      this.formEstado = this.fb.group({
        fechaEstado: [fechaActual]
      });

      this.hoy = this.formatoFecha(hoy);

      await Promise.all([
        this.cargarDataAdmin(),
        this.cargarVehiculos(),
        this.cargarConductor()
      ]);

    } catch (error) {
      console.error('Error cargando datos del formulario:', error);
    } finally {
      this.adminSeafLoadingService.ocultar();
    }
  }

  private cargarVehiculos(): void {
    this.vehiclesService.getPlacasAll().subscribe({
      next: (data) => (this.vehiculos = data),
      error: (error) => console.error("❌ Error al obtener vehículos:", error),
    });
  }

  private cargarConductor(): void {
    this.propietariosService.getConductores().subscribe({
      next: (data) => (this.conductor = data.data), // 👈 Solo asignas el array
      error: (error) => console.error("❌ Error al obtener el taller:", error),
    });
  }

  generarDatosGrafico(): void {
    const conteo: Record<string, number> = {
      'REALIZADO': 0,
      'NO REALIZADO': 0
    };

    if (!this.estadoPreoperacional || !this.estadoPreoperacional.length) {
      this.chartSeries = [];
      return;
    }

    this.estadoPreoperacional.forEach(v => {
      const estado = v.estado_preoperacional?.toUpperCase() || 'NO DEFINIDO';
      conteo[estado] = (conteo[estado] || 0) + 1;
    });

    // Orden fijo para evitar que cambien los colores
    const estados = ['REALIZADO', 'NO REALIZADO', 'NO DEFINIDO'];

    this.chartSeries = estados.map(e => conteo[e] || 0);

    this.chartOptions = {
      chart: {
        type: 'pie',
        width: '100%',
        height: 350  // 🔧 Ajusta la altura aquí (px)
      },
      labels: estados,
      colors: ['#54BA4A', '#FC4438', '#6c757d'],
      legend: {
        position: 'bottom'
      },
      title: {
        text: 'Resumen por Estado',
        align: 'center'
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: { width: 500 },
            legend: { position: 'bottom' }
          }
        }
      ]
    };
  }


  buscarPreoperacionales(): void {
    const placa = this.formPreoperacionales.value.placa?.trim();
    const conductor = this.formPreoperacionales.value.conductor;
    const fecha = this.formPreoperacionales.value.fecha?.trim();
    const fechaFinal = this.formPreoperacionales.value.fechaFinal?.trim();

    // Validar fechas obligatorias
    if (!fecha) {
      this.mostrarAlerta(
        'Campo requerido',
        'Por favor, selecciona la fecha inicial',
        'info'
      );
      return;
    }

    if (!fechaFinal) {
      this.mostrarAlerta(
        'Campo requerido',
        'Por favor, selecciona la fecha final',
        'info'
      );
      return;
    }

    // Validar rango de fechas
    if (fecha > fechaFinal) {
      this.mostrarAlerta(
        'Rango de fechas inválido',
        'La fecha inicial no puede ser posterior a la fecha final.',
        'warning'
      );
      return;
    }

    this.adminSeafLoadingService.mostrar(
      'Consultando alistamientos',
      [
        {
          id: 'busqueda',
          nombre: 'Buscando preoperacionales',
          icono: '📝',
          visible: false,
          estado: 'cargando'
        }
      ],
      'por favor espere...'
    );

    this.preoperacionalesService
      .getAlistamientoByPlacaYFecha({
        placa,
        conductor,
        fecha,
        fechaFinal
      })
      .pipe(
        finalize(() => {
          this.adminSeafLoadingService.ocultar();
        })
      )
      .subscribe({
        next: (resp) => {
          const registros = resp?.preoperacional ?? [];

          this.resultadosPreoperacionales = registros;
          this.filteredPreoperacionales = [...registros];
          this.mensajeBusqueda = resp?.mensaje ?? '';
          this.mostrarTabla = true;

          if (registros.length === 0) {
            this.mensajeBusqueda =
              resp?.mensaje || 'No se encontraron alistamientos para los filtros seleccionados.';
          }
        },
        error: (err) => {
          console.error('Error al buscar alistamientos:', err);

          this.resultadosPreoperacionales = [];
          this.filteredPreoperacionales = [];
          this.mensajeBusqueda =
            'Ocurrió un error al buscar los alistamientos.';
          this.mostrarTabla = true;

          this.mostrarAlerta(
            'Error',
            'No fue posible consultar los alistamientos. Intenta nuevamente.',
            'error'
          );
        }
      });
  }

  private mostrarAlerta(titulo: string, mensaje: string, icono: any) {
    Swal.fire({
      title: titulo,
      text: mensaje,
      icon: icono,
      confirmButtonColor: "#3085d6",
    });
  }

  actualizarMinFechaFinal(): void {
    const fechaInicialStr = this.formPreoperacionales.get("fecha")?.value;

    if (fechaInicialStr) {
      const fechaInicial = new Date(fechaInicialStr);
      const fechaFinal = new Date(fechaInicial);
      fechaFinal.setDate(fechaFinal.getDate() + 1); // suma 1 día

      // Formato local: yyyy-MM-dd
      this.minFechaFinal = [
        fechaFinal.getFullYear(),
        String(fechaFinal.getMonth() + 1).padStart(2, '0'),
        String(fechaFinal.getDate()).padStart(2, '0')
      ].join('-');

      const fechaFinalControl = this.formPreoperacionales.get("fechaFinal");
      if (
        fechaFinalControl?.value &&
        fechaFinalControl.value < this.minFechaFinal
      ) {
        fechaFinalControl.setValue("");
      }
    }
  }


  formatoFecha(fecha: Date): string {
    // Los inputs date esperan una fecha calendario, no una fecha convertida a UTC.
    return `${fecha.getFullYear()}-${String(fecha.getMonth() + 1).padStart(2, '0')}-${String(fecha.getDate()).padStart(2, '0')}`;
  }
  // ✅ Resta días exactos a una fecha
  restarDias(fecha: Date, dias: number): Date {
    const nuevaFecha = new Date(fecha);
    nuevaFecha.setDate(nuevaFecha.getDate() - dias);
    return nuevaFecha;
  }
  // ✅ Selecciona el rango dinámicamente según el botón presionado
  seleccionarRango(
    rango: "dia" | "semana" | "mes" | "trimestre" | "semestre" | "anio"
  ): void {
    const hoy = new Date(); // 📅 Fecha actual
    let diasARestar = 0;

    switch (rango) {
      case "dia":
        diasARestar = 1;
        break;
      case "semana":
        diasARestar = 7;
        break;
      case "mes":
        diasARestar = 30;
        break;
      case "trimestre":
        diasARestar = 90;
        break;
      case "semestre":
        diasARestar = 180;
        break;
      case "anio":
        diasARestar = 365;
        break;
    }

    const fechaInicio = this.restarDias(hoy, diasARestar);
    const fechaInicioStr = this.formatoFecha(fechaInicio);
    const fechaFinStr = this.formatoFecha(hoy);

    this.minFechaFinal = fechaInicioStr;

    this.formPreoperacionales.patchValue({
      fecha: fechaInicioStr,
      fechaFinal: fechaFinStr,
    });
  }

  filterData() {
    const search = this.searchText?.toLowerCase() || "";

    if (!search) {
      this.filteredPreoperacionales = [...this.resultadosPreoperacionales];
      return;
    }

    this.filteredPreoperacionales = this.resultadosPreoperacionales.filter(
      (item) =>
        (item.placa + "").toLowerCase().includes(search) ||
        (item.fecha + "").toLowerCase().includes(search) ||
        (item.cedula + "").toLowerCase().includes(search)
    );

    this.page1 = 1;
  }

  //recibe el id de la tabla vista, nombre con el que descargará el archivo, titulo del documento
  exportToPDF(tableId: string, nameFile: string, titleFile: string) {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }

  exportarExcel(tableId: string, nameFile: string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  addHeader(doc: jsPDF) {
    const pageWidth = 216; // Ancho total en mm (Letter)
    const marginLeft = 5; // Margen izquierdo deseado
    const marginRight = 5; // Margen derecho igual para simetría
    const rectY = 3; // Distancia desde la parte superior
    const headerHeight = 20; // Altura del encabezado
    const rectWidth = pageWidth - marginLeft - marginRight;

    // Dibujar el rectángulo del encabezado
    doc.setDrawColor(0, 0, 0); // Borde negro
    doc.setLineWidth(0.5); // Grosor del borde
    doc.rect(marginLeft, rectY, rectWidth, headerHeight);

    // Título centrado dentro del rectángulo
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);

    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);

    doc.text(
      [
        "FORMATO DE INSPECCIÓN PREOPERACIONAL",
        "DE VEHÍCULOS Y EQUIPOS"
      ],
      105,
      12,
      { align: "center" }
    );
  }

  addFooter(doc: jsPDF, currentPage: number, totalPages: number) {
    const pageHeight = doc.internal.pageSize.height;
    const now = new Date();
    const fecha = now.toLocaleDateString("es-CO", {
      day: "numeric",
      month: "long",
      year: "numeric"
    });
    const hora = now.toLocaleTimeString("es-CO", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    });
    const fechaHora = `${fecha} - ${hora}`;

    doc.setFont("helvetica", "italic");
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);

    // Línea de pie centrada
    // Enlace clicable en el centro
    /*    const linkText = "Generado desde Admin SEAF – INDESOFT SAS";
       doc.textWithLink(linkText, 105, pageHeight - 12, {
         url: "https://indesoftsas.com",
         align: "center"
       }); */

    // Fecha y hora a la izquierda
    doc.text(
      `${fechaHora}`,
      10,
      pageHeight - 5
    );

    // Número de página a la derecha
    doc.text(
      `Página ${currentPage} de ${totalPages}`,
      200,
      pageHeight - 5,
      { align: "right" }
    );
  }

  async addQRCode(doc: jsPDF, data: string, x: number, y: number, size: number = 40) {
    try {
      const qrDataUrl = await QRCode.toDataURL(data, { width: size, margin: 1 });
      doc.addImage(qrDataUrl, "PNG", x, y, size, size);
    } catch (err) {
      console.error("Error al generar QR:", err);
    }
  }

  async addHeaderImages(
    doc: jsPDF,
    gpcGoogle: any,
    imageMap: Record<string, { path: string; x: number; y: number; w: number; h: number }>,
    fallbackPath: string
  ) {
    // ¿La ruta es un asset local (no viene de Google Cloud Storage)?
    const isLocalAsset = (path: string) =>
      path.includes("assets/") || path.startsWith("./") || path.startsWith("../");

    // Normaliza rutas relativas: "../../../../assets/..." → "assets/..."
    const normalizeLocalPath = (path: string) =>
      path.replace(/^(\.\.\/)+/, "").replace(/^\.\//, "");

    // Carga un asset local como base64
    const loadLocalAssetBase64 = async (path: string): Promise<string | null> => {
      try {
        return await gpcGoogle.getImageBase64(normalizeLocalPath(path));
      } catch {
        return null;
      }
    };

    // Obtener URL firmada de forma segura (solo para rutas de GCS)
    const getSignedUrlSafe = async (path: string) => {
      if (isLocalAsset(path)) return null; // los assets locales no se firman
      try {
        const res = await gpcGoogle.getSignedUrl(path).toPromise();
        return res?.url || null;
      } catch {
        return null;
      }
    };

    // Obtener imagen en base64, con fallback
    const getBase64WithFallback = async (path: string, url: string | null, fallbackPath: string) => {
      if (isLocalAsset(path)) {
        return await loadLocalAssetBase64(path);
      }
      if (url) {
        try {
          return await gpcGoogle.getImageBase64(url);
        } catch {
          // fallback
        }
      }
      return await loadLocalAssetBase64(fallbackPath);
    };

    // Comprimir base64 usando canvas
    const compressBase64Image = async (base64: string, quality = 0.1): Promise<string> => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          if (!ctx) return reject("No canvas context");
          ctx.drawImage(img, 0, 0);
          const compressed = canvas.toDataURL("image/png", quality); // quality 0–1
          resolve(compressed);
        };
        img.onerror = reject;
        img.src = base64;
      });
    };

    // 1. Obtener las claves y rutas
    const imageEntries = Object.entries(imageMap);

    // 2. Obtener URLs firmadas
    const signedUrls = await Promise.all(
      imageEntries.map(([_, img]) => getSignedUrlSafe(img.path))
    );

    // 3. Obtener y comprimir Base64
    const base64Images = await Promise.all(
      signedUrls.map(async (url, index) => {
        const base64 = await getBase64WithFallback(imageEntries[index][1].path, url, fallbackPath);
        return base64 ? await compressBase64Image(base64, 0.6) : null; // puedes ajustar el 0.6
      })
    );

    // 4. Agregar imágenes al PDF
    base64Images.forEach((base64, idx) => {
      if (base64) {
        const { x, y, w, h } = imageEntries[idx][1];
        doc.addImage(base64, "JPEG", x, y, w, h, undefined, "FAST");
      }
    });
  }

  async GenerarFichaPreo(id: number, servicio: number): Promise<void> {

    //  this.mostrandoToast = true;
    this.adminSeafLoadingService.mostrar(
      'Generando ficha de alistamiento',
      [
        {
          id: 'consulta',
          nombre: 'Consultando alistamiento',
          icono: '🔎',
          visible: true,
          estado: 'cargando'
        },
        {
          id: 'vehiculo',
          nombre: 'Procesando datos del vehículo',
          icono: '🚍',
          visible: true,
          estado: 'pendiente'
        },
        {
          id: 'documentos',
          nombre: 'Generando tablas y evaluaciones',
          icono: '📋',
          visible: true,
          estado: 'pendiente'
        },
        {
          id: 'evidencias',
          nombre: 'Cargando evidencias fotográficas',
          icono: '📸',
          visible: true,
          estado: 'pendiente'
        },
        {
          id: 'finalizar',
          nombre: 'Preparando documento PDF',
          icono: '📄',
          visible: true,
          estado: 'pendiente'
        }
      ],
      'Estamos preparando la ficha de alistamiento. Por favor, espera...'
    );
    try {

      // ============================================================
      // 1. OBTENER INFORMACIÓN DEL ALISTAMIENTO
      // ============================================================

      const resp = await firstValueFrom(
        this.preoperacionalesService.getPreoperacionalById(id)
      );

      if (!resp) {

        this.mostrandoToast = false;

        await Swal.fire({
          title: 'Información',
          text: 'Sin datos del alistamiento',
          icon: 'info',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#3085d6'
        });

        return;
      }

      this.resultadoPreo = resp;
      this.adminSeafLoadingService.actualizarPaso(
        'consulta',
        { estado: 'completado' },
        'Alistamiento consultado correctamente'
      );

      this.adminSeafLoadingService.actualizarPaso(
        'vehiculo',
        { estado: 'cargando' },
        'Identificando el vehículo y su servicio'
      );
      // ============================================================
      // 2. IDENTIFICAR TIPO DE VEHÍCULO
      // ============================================================

      this.isPermitidoMotos =
        this.tiposVehiculosMotos.includes(
          this.resultadoPreo.vehicle?.clase
        );

      this.isParticulares =
        this.resultadoPreo.vehicle?.servicio === 2;

      this.adminSeafLoadingService.actualizarPaso(
        'vehiculo',
        { estado: 'completado' },
        'Datos del vehículo procesados'
      );

      this.adminSeafLoadingService.actualizarPaso(
        'documentos',
        { estado: 'cargando' },
        'Construyendo tablas y evaluaciones'
      );
      // ============================================================
      // 3. CREAR PDF
      // ============================================================

      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'letter'
      });


      // ============================================================
      // FUNCIONES AUXILIARES
      // ============================================================

      const formatValue = (val: any): string => {

        if (val === undefined || val === null) {
          return 'NO';
        }

        return String(val);
      };


      const dibujarEncabezadoPrincipal = async (): Promise<void> => {
        doc.setFont(
          'helvetica',
          'bold'
        );
        this.addHeader(doc);

        /*
         * Se conserva la lógica original:
         *
         * Particulares -> ministerio
         * Otros       -> logo-login
         */

        if (!this.isParticulares) {

          await this.addHeaderImages(
            doc,
            this.gpcGoogle,
            {
              supertransporte: {
                path: 'ministerio/supertransporte.png',
                x: 170,
                y: 7,
                w: 35,
                h: 12
              },

              logo: {
                path: `${this.administraciones[0].nit}/logos/logo.png`,
                x: this.posicionX,
                y: this.posicionY,
                w: this.ancho,
                h: this.altura
              }
            },
            '../../../../../assets/images/hoja_vida/sinfoto.png'
          );

        } else {

          await this.addHeaderImages(
            doc,
            this.gpcGoogle,
            {
              supertransporte: {
                path: 'assets/images/logo/logo-login.png',
                x: 170,
                y: 7,
                w: 35,
                h: 12
              },

              logo: {
                path: `${this.administraciones[0].nit}/logos/logo.png`,
                x: this.posicionX,
                y: this.posicionY,
                w: this.ancho,
                h: this.altura
              }
            },
            '../../../../../assets/images/hoja_vida/sinfoto.png'
          );
        }
      };


      // ============================================================
      // 4. ENCABEZADO PÁGINA 1
      // ============================================================

      await dibujarEncabezadoPrincipal();


      // ============================================================
      // 5. TÍTULO DATOS DEL VEHÍCULO
      // ============================================================

      doc.setFillColor(230, 230, 230);
      doc.setDrawColor(200);

      doc.roundedRect(
        5,
        25,
        206,
        12,
        0,
        0,
        'FD'
      );

      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(40, 40, 40);

      doc.text(
        'DATOS DEL VEHÍCULO',
        105,
        33,
        {
          align: 'center'
        }
      );


      // ============================================================
      // 6. FECHA / HORA
      // ============================================================

      const fecha = this.resultadoPreo.fecha
        ? new Date(this.resultadoPreo.fecha)
        : null;

      const hora = this.resultadoPreo.hora || '';

      const fechaFormateada = fecha
        ? `${String(fecha.getUTCDate()).padStart(2, '0')}-${String(
          fecha.getUTCMonth() + 1
        ).padStart(2, '0')}-${fecha.getUTCFullYear()}`
        : '';

      const resultadoFecha = `${fechaFormateada} ${hora}`.trim();


      // ============================================================
      // 7. INFORMACIÓN DEL VEHÍCULO
      // ============================================================

      const infoVehiculo = [

        [
          'ID:',
          String(this.resultadoPreo.id ?? '')
        ],

        [
          'FECHA Y HORA:',
          resultadoFecha
        ],

        [
          'PLACA Y INTERNO:',
          `${this.resultadoPreo.placa || ''} - ${this.resultadoPreo.vehicle?.interno || ''
            }`.trim()
        ],

        [
          'KILOMETRAJE:',
          String((this.resultadoPreo.kilometraje ?? '') + " KM")
        ],

        [
          'LICENCIA:',
          String(this.resultadoPreo.cedula ?? '')
        ],

        [
          'CONDUCTOR:',
          `${this.resultadoPreo.conductor || ''}`
            .trim()
            .toUpperCase()
        ]

      ];


      const drawDatosVehiculo = (): number => {

        const rowHeight = 7;
        const titleWidth = 35;
        const valueWidth = 68;
        const startX = 5;
        const startY = 37;


        doc.setFontSize(9);


        for (
          let i = 0;
          i < infoVehiculo.length;
          i++
        ) {

          const row =
            Math.floor(i / 2);

          const col =
            i % 2;

          const x =
            startX +
            col *
            (titleWidth + valueWidth);

          const y =
            startY +
            row * rowHeight;


          // Label
          doc.setFillColor(
            230,
            230,
            230
          );

          doc.setDrawColor(
            200,
            200,
            200
          );

          doc.rect(
            x,
            y,
            titleWidth,
            rowHeight,
            'FD'
          );


          doc.setTextColor(0);

          doc.setFont(
            'helvetica',
            'bold'
          );

          doc.text(
            infoVehiculo[i][0],
            x + 2,
            y + 5
          );


          // Valor
          doc.setFillColor(
            255,
            255,
            255
          );

          doc.rect(
            x + titleWidth,
            y,
            valueWidth,
            rowHeight,
            'FD'
          );


          doc.setFont(
            'helvetica',
            'normal'
          );

          doc.setTextColor(0);

          doc.text(
            String(infoVehiculo[i][1]),
            x + titleWidth + 2,
            y + 5
          );
        }


        return (
          startY +
          Math.ceil(
            infoVehiculo.length / 2
          ) *
          rowHeight +
          10
        );
      };


      // ============================================================
      // 8. FUNCIÓN GENÉRICA PARA TABLAS
      // ============================================================

      const renderTablaEstado = (
        y: number,
        titulo: string,
        conceptos: string[],
        evaluaciones: string[]
      ): number => {

        const rowH = 7;

        const xItem = 5;
        const widthItem = 45;

        const xConcepto = 50;
        const widthConcepto = 100;

        const xEvaluacion = 150;
        const widthEvaluacion = 61;

        const totalWidth =
          widthItem +
          widthConcepto +
          widthEvaluacion;


        // ==========================================================
        // ENCABEZADO
        // ==========================================================

        doc.setFillColor(
          230, 230, 230
        );

        doc.setDrawColor(
          230, 230, 230
        );

        doc.roundedRect(
          xItem,
          y - 6,
          totalWidth,
          rowH,
          1,
          1,
          'FD'
        );


        doc.setDrawColor(
          230,
          230,
          230
        );

        doc.setLineWidth(
          0.2
        );


        doc.line(
          xConcepto,
          y - 6,
          xConcepto,
          y + 1
        );


        doc.line(
          xEvaluacion,
          y - 6,
          xEvaluacion,
          y + 1
        );


        doc.setFont(
          'helvetica',
          'bold'
        );

        doc.setFontSize(8);

        doc.setTextColor(
          0,
          0,
          0
        );


        doc.text(
          'ITEM',
          xItem + widthItem / 2,
          y - 1.5,
          {
            align: 'center'
          }
        );


        doc.text(
          'CONCEPTO',
          xConcepto + widthConcepto / 2,
          y - 1.5,
          {
            align: 'center'
          }
        );


        doc.text(
          'EVALUACIÓN',
          xEvaluacion + widthEvaluacion / 2,
          y - 1.5,
          {
            align: 'center'
          }
        );


        // ==========================================================
        // CUERPO
        // ==========================================================

        const bodyY = y + 1;

        const bodyHeight =
          conceptos.length *
          rowH;


        // Columna categoría

        doc.setFillColor(
          245,
          245,
          245
        );

        doc.setDrawColor(
          205,
          205,
          205
        );

        doc.rect(
          xItem,
          bodyY,
          widthItem,
          bodyHeight,
          'FD'
        );


        // Título categoría

        doc.setFont(
          'helvetica',
          'bold'
        );

        doc.setFontSize(9);

        doc.setTextColor(
          35,
          35,
          35
        );


        doc.text(
          titulo,
          xItem + widthItem / 2,
          bodyY + bodyHeight / 2,
          {
            align: 'center'
          }
        );


        // Línea decorativa

        doc.setDrawColor(
          77,
          77,
          77
        );

        doc.setLineWidth(1);


        doc.line(
          xItem + 10,
          bodyY + bodyHeight / 2 + 5,
          xItem + widthItem - 10,
          bodyY + bodyHeight / 2 + 5
        );


        // ==========================================================
        // FILAS
        // ==========================================================

        for (
          let i = 0;
          i < conceptos.length;
          i++
        ) {

          const posY =
            bodyY +
            i * rowH;


          // --------------------------------------------------------
          // CONCEPTO
          // --------------------------------------------------------

          doc.setFillColor(
            i % 2 === 0
              ? 255
              : 250,
            i % 2 === 0
              ? 255
              : 250,
            i % 2 === 0
              ? 255
              : 250
          );

          doc.setDrawColor(
            205,
            205,
            205
          );

          doc.setLineWidth(
            0.25
          );


          doc.rect(
            xConcepto,
            posY,
            widthConcepto,
            rowH,
            'FD'
          );


          doc.setFont(
            'helvetica',
            'normal'
          );


          doc.setFontSize(
            conceptos[i].length > 50
              ? 7
              : 8
          );


          doc.setTextColor(
            35,
            35,
            35
          );


          doc.text(
            conceptos[i],
            xConcepto + 2,
            posY + 4.7
          );


          // --------------------------------------------------------
          // EVALUACIÓN
          // --------------------------------------------------------

          doc.setFillColor(
            255,
            255,
            255
          );


          doc.rect(
            xEvaluacion,
            posY,
            widthEvaluacion,
            rowH,
            'FD'
          );


          const valor =
            String(
              evaluaciones[i] ?? 'NO'
            ).trim();


          const valorUpper =
            valor.toUpperCase();


          const badgeX =
            xEvaluacion + 3;

          const badgeY =
            posY + 1.2;

          const badgeWidth =
            widthEvaluacion - 6;

          const badgeHeight =
            rowH - 2.4;


          // --------------------------------------------------------
          // SI
          // --------------------------------------------------------

          if (valorUpper === 'SI') {

            doc.setFillColor(
              225,
              245,
              230
            );

            doc.roundedRect(
              badgeX,
              badgeY,
              badgeWidth,
              badgeHeight,
              2,
              2,
              'F'
            );


            doc.setFillColor(
              25,
              130,
              70
            );

            doc.circle(
              xEvaluacion + 12,
              posY + rowH / 2,
              1.5,
              'F'
            );


            doc.setTextColor(
              20,
              105,
              55
            );

            doc.setFont(
              'helvetica',
              'bold'
            );

            doc.setFontSize(7);


            doc.text(
              'SI',
              xEvaluacion +
              widthEvaluacion / 2 +
              5,
              posY + 4.6,
              {
                align: 'center'
              }
            );
          }


          // --------------------------------------------------------
          // NO
          // --------------------------------------------------------

          else if (
            valorUpper === 'NO'
          ) {

            doc.setFillColor(
              252,
              230,
              230
            );

            doc.roundedRect(
              badgeX,
              badgeY,
              badgeWidth,
              badgeHeight,
              2,
              2,
              'F'
            );


            doc.setFillColor(
              200,
              35,
              45
            );

            doc.circle(
              xEvaluacion + 12,
              posY + rowH / 2,
              1.5,
              'F'
            );


            doc.setTextColor(
              180,
              30,
              40
            );

            doc.setFont(
              'helvetica',
              'bold'
            );

            doc.setFontSize(7);


            doc.text(
              'NO',
              xEvaluacion +
              widthEvaluacion / 2 +
              5,
              posY + 4.6,
              {
                align: 'center'
              }
            );
          }


          // --------------------------------------------------------
          // BUENO
          // --------------------------------------------------------

          else if (
            valorUpper === 'BUENO'
          ) {

            doc.setFillColor(
              232,
              245,
              236
            );

            doc.roundedRect(
              badgeX,
              badgeY,
              badgeWidth,
              badgeHeight,
              2,
              2,
              'F'
            );


            doc.setFillColor(
              25,
              130,
              70
            );

            doc.circle(
              xEvaluacion + 12,
              posY + rowH / 2,
              1.5,
              'F'
            );


            doc.setTextColor(
              25,
              105,
              55
            );

            doc.setFont(
              'helvetica',
              'bold'
            );

            doc.setFontSize(7);


            doc.text(
              'BUENO',
              xEvaluacion +
              widthEvaluacion / 2 +
              5,
              posY + 4.6,
              {
                align: 'center'
              }
            );
          }


          // --------------------------------------------------------
          // OTROS
          // --------------------------------------------------------

          else {

            doc.setFillColor(
              245,
              245,
              245
            );

            doc.roundedRect(
              badgeX,
              badgeY,
              badgeWidth,
              badgeHeight,
              2,
              2,
              'F'
            );


            doc.setTextColor(
              70,
              70,
              70
            );

            doc.setFont(
              'helvetica',
              'bold'
            );

            doc.setFontSize(7);


            doc.text(
              valor,
              xEvaluacion +
              widthEvaluacion / 2,
              posY + 4.6,
              {
                align: 'center'
              }
            );
          }
        }


        return (
          bodyY +
          bodyHeight +
          3
        );
      };


      // ============================================================
      // 9. DOCUMENTOS
      // ============================================================

      let yPos =
        drawDatosVehiculo();


      let conceptosDocumentos: string[];

      let evaluacionesDocumentos: string[];


      if (
        this.isPermitidoMotos ||
        this.isParticulares
      ) {

        conceptosDocumentos = [

          'LICENCIA DE TRÁNSITO',
          'SOAT',
          'REVISIÓN TÉCNICO-MECÁNICA',
          'LICENCIA DE CONDUCCIÓN'

        ];


        evaluacionesDocumentos = [

          formatValue(
            this.resultadoPreo.transito
          ),

          formatValue(
            this.resultadoPreo.soat
          ),

          formatValue(
            this.resultadoPreo.cda
          ),

          formatValue(
            this.resultadoPreo.licencia
          )

        ];

      } else {

        conceptosDocumentos = [

          'LICENCIA DE TRÁNSITO',
          'TARJETA DE OPERACIÓN',
          'SOAT',
          'REVISIÓN TÉCNICO-MECÁNICA',
          'PÓLIZA RCC Y PÓLIZA RCE',
          'LICENCIA DE CONDUCCIÓN'

        ];


        evaluacionesDocumentos = [

          formatValue(
            this.resultadoPreo.transito
          ),

          formatValue(
            this.resultadoPreo.operacion
          ),

          formatValue(
            this.resultadoPreo.soat
          ),

          formatValue(
            this.resultadoPreo.cda
          ),

          formatValue(
            this.resultadoPreo.rcc
          ),

          /*  formatValue(
             this.resultadoPreo.rce
           ), */

          formatValue(
            this.resultadoPreo.licencia
          )

        ];
      }


      yPos =
        renderTablaEstado(
          yPos,
          'DOCUMENTOS',
          conceptosDocumentos,
          evaluacionesDocumentos
        );

      yPos = yPos + 5;
      // ============================================================
      // 10. ESTADO MECÁNICO
      // ============================================================

      let conceptosMecanico: string[];

      let evaluacionesMecanico: string[];


      if (
        this.isPermitidoMotos
      ) {

        conceptosMecanico = [

          'TRANSMISIÓN (CADENA, CORONA Y PIÑÓN)',
          'SUSPENSIÓN / DIRECCIÓN',
          'ACEITE DEL MOTOR Y COMBUSTIBLE',
          'FUGAS DE ACEITE O COMBUSTIBLE',
          'CADENA (TENSIÓN Y LUBRICACIÓN)',
          'CONEXIONES ELÉCTRICAS'

        ];


        evaluacionesMecanico = [

          formatValue(
            this.resultadoPreo.caja
          ),

          formatValue(
            this.resultadoPreo.suspension
          ),

          formatValue(
            this.resultadoPreo.agua
          ),

          formatValue(
            this.resultadoPreo.fugas
          ),

          formatValue(
            this.resultadoPreo.cadena
          ),

          formatValue(
            this.resultadoPreo.electricos
          )

        ];

      } else {

        conceptosMecanico = [

          'CAJA DE CAMBIOS / TRANSMISIÓN',
          'SUSPENSIÓN / DIRECCIÓN',
          'NIVEL DE AGUA, ACEITE, COMBUSTIBLE Y FLUIDOS',
          'FUGAS DEL MOTOR',
          'CORREAS',
          'CONEXIONES ELÉCTRICAS',
          'FILTROS HÚMEDOS Y SECOS'

        ];


        evaluacionesMecanico = [

          formatValue(
            this.resultadoPreo.caja
          ),

          formatValue(
            this.resultadoPreo.suspension
          ),

          formatValue(
            this.resultadoPreo.agua
          ),

          formatValue(
            this.resultadoPreo.fugas
          ),

          formatValue(
            this.resultadoPreo.correas
          ),

          formatValue(
            this.resultadoPreo.electricos
          ),

          formatValue(
            this.resultadoPreo.filtroshs
          )

        ];
      }


      yPos =
        renderTablaEstado(
          yPos,
          'ESTADO MECÁNICO',
          conceptosMecanico,
          evaluacionesMecanico
        );

      yPos = yPos + 5;
      // ============================================================
      // 11. ESTADO DE CABINA
      // ============================================================

      let conceptosCabina: string[];

      let evaluacionesCabina: string[];


      // ------------------------------------------------------------
      // MOTOS
      // ------------------------------------------------------------

      if (
        this.isPermitidoMotos
      ) {

        conceptosCabina = [

          'ESPEJO DERECHO',
          'ESPEJO IZQUIERDO',
          'PITO',
          'TAPAS Y CARENAJES',
          'FRENO DELANTERO',
          'FRENO TRASERO',
          'ASIENTO',
          'INDICADORES DEL TABLERO (VELOCÍMETRO, COMBUSTIBLE, TESTIGOS)',
          'ESTRIBERAS (REPOSA PIES)',
          'BATERÍA, BORNES Y CABLES',
          'CASCO',
          'VISOR DEL CASCO',
          'SOPORTE DE LA PLACA',
          'GUARDA BARROS',
          'PATAL LATERAL',
          'EMISIÓN DE GASES'

        ];


        evaluacionesCabina = [

          formatValue(
            this.resultadoPreo.espejo
          ),

          formatValue(
            this.resultadoPreo.laterales
          ),

          formatValue(
            this.resultadoPreo.alarma
          ),

          formatValue(
            this.resultadoPreo.tapas
          ),

          formatValue(
            this.resultadoPreo.frenos
          ),

          formatValue(
            this.resultadoPreo.frenoe
          ),

          formatValue(
            this.resultadoPreo.asientos
          ),

          formatValue(
            this.resultadoPreo.tablero
          ),

          formatValue(
            this.resultadoPreo.estribos
          ),

          formatValue(
            this.resultadoPreo.baterias
          ),

          formatValue(
            this.resultadoPreo.casco
          ),

          formatValue(
            this.resultadoPreo.visor_casco
          ),

          formatValue(
            this.resultadoPreo.soporte_placa
          ),

          formatValue(
            this.resultadoPreo.guardabarro
          ),

          formatValue(
            this.resultadoPreo.pata_lateral
          ),

          formatValue(
            this.resultadoPreo.gases
          )

        ];

      }

      // ------------------------------------------------------------
      // VEHÍCULOS
      // ------------------------------------------------------------

      else {

        conceptosCabina = [

          'ESPEJO CENTRAL CONVEXO',
          'ESPEJOS LATERALES',
          'ALARMA DE RETROCESO Y PITO',
          'TAPAS',
          'FRENO DE SERVICIO',
          'FRENO DE EMERGENCIA',
          'VIDRIO FRONTAL / LIMPIABRISAS',
          'BOTIQUÍN, EQUIPO DE CARRETERA',
          'EXTINTOR DE INCENDIOS',
          'ASIENTOS Y TAPICERÍA',
          'SENSORES DEL TABLERO: (KM/H, BATERÍA, TEMPERATURA, COMBUSTIBLE)',
          'ESTRIBOS',
          'BATERÍA, BORNES, CABLES, NIV. DE ELECTROLITO Y SULFATACIÓN'

        ];


        evaluacionesCabina = [

          formatValue(
            this.resultadoPreo.espejo
          ),

          formatValue(
            this.resultadoPreo.laterales
          ),

          formatValue(
            this.resultadoPreo.alarma
          ),

          formatValue(
            this.resultadoPreo.tapas
          ),

          formatValue(
            this.resultadoPreo.frenos
          ),

          formatValue(
            this.resultadoPreo.frenoe
          ),

          formatValue(
            this.resultadoPreo.vidrios
          ),

          formatValue(
            this.resultadoPreo.botiquin
          ),

          formatValue(
            this.resultadoPreo.extintor
          ),

          formatValue(
            this.resultadoPreo.asientos
          ),

          formatValue(
            this.resultadoPreo.tablero
          ),

          formatValue(
            this.resultadoPreo.estribos
          ),

          formatValue(
            this.resultadoPreo.baterias
          )

        ];
      }


      yPos =
        renderTablaEstado(
          yPos,
          this.isPermitidoMotos
            ? 'ESTADO GENERAL'
            : 'ESTADO DE CABINA',
          conceptosCabina,
          evaluacionesCabina
        );

      yPos = yPos + 3;
      // ============================================================
      // 12. SEGUNDA PÁGINA
      // ============================================================

      doc.addPage();

      await dibujarEncabezadoPrincipal();


      yPos = 32;


      // ============================================================
      // 13. ESTADO DE LUCES
      // ============================================================

      const conceptosLuces = [

        this.isPermitidoMotos
          ? 'LUCES ALTAS Y BAJAS'
          : 'LUCES EXTERIORES ALTAS Y BAJAS',

        'LUCES DIRECCIONALES DELANTERAS',
        'LUCES DIRECCIONALES TRASERAS',
        'LUCES DE ESTACIONAMIENTO',
        'LUCES DE STOP'

      ];


      const evaluacionesLuces = [

        formatValue(
          this.resultadoPreo.altas
        ),

        formatValue(
          this.resultadoPreo.delanteras
        ),

        formatValue(
          this.resultadoPreo.traseras
        ),

        formatValue(
          this.resultadoPreo.estacionarias
        ),

        formatValue(
          this.resultadoPreo.stop
        )

      ];


      yPos =
        renderTablaEstado(
          yPos,
          'ESTADO DE LUCES',
          conceptosLuces,
          evaluacionesLuces
        );

      yPos = yPos + 5;
      // ============================================================
      // 14. LLANTAS
      // ============================================================

      const conceptosLlantas =
        this.isPermitidoMotos

          ? [

            'ESTADO GENERAL DE LAS LLANTAS',
            'PRESIÓN DEL AIRE'

          ]

          : [

            'ESTADO GENERAL DE LAS LLANTAS',
            'PRESIÓN DEL AIRE',
            'LLANTA DE REPUESTOS'

          ];


      const evaluacionesLlantas = [

        formatValue(
          this.resultadoPreo.llantas
        ),

        formatValue(
          this.resultadoPreo.presion
        ),

        formatValue(
          this.resultadoPreo.repuesto
        )

      ];


      yPos =
        renderTablaEstado(
          yPos,
          'LLANTAS',
          conceptosLlantas,
          evaluacionesLlantas
        );


      // ============================================================
      // 15. OBSERVACIONES
      // ============================================================

      const observacion =
        formatValue(
          this.resultadoPreo.observaciones
        );


      const xItemObs = 5;
      const widthItemObs = 45;
      const xTextoObs = 50;
      const widthTextoObs = 161;
      const alturaObs = 25;


      doc.setFillColor(
        245,
        245,
        245
      );

      doc.setDrawColor(
        205,
        205,
        205
      );


      doc.rect(
        xItemObs,
        yPos + 3,
        widthItemObs,
        alturaObs,
        'FD'
      );


      doc.setFont(
        'helvetica',
        'bold'
      );

      doc.setFontSize(9);

      doc.setTextColor(
        35,
        35,
        35
      );


      doc.text(
        'OBSERVACIONES',
        xItemObs +
        widthItemObs / 2,
        yPos + 17,
        {
          align: 'center'
        }
      );


      doc.setFillColor(
        255,
        255,
        255
      );


      doc.rect(
        xTextoObs,
        yPos + 3,
        widthTextoObs,
        alturaObs,
        'FD'
      );


      doc.setFont(
        'helvetica',
        'normal'
      );

      doc.setFontSize(8);


      const lineasObservacion =
        doc.splitTextToSize(
          observacion,
          widthTextoObs - 5
        );


      doc.text(
        lineasObservacion.slice(0, 5),
        xTextoObs + 3,
        yPos + 9
      );


      yPos +=
        alturaObs +
        10;


      // ============================================================
      // 16. FIRMAS
      // ============================================================

      const renderFirmas = async (
        y: number,
        nombreConductor: string,
        cedulaConductor: string
      ): Promise<void> => {

        const height = 10;

        const widthFirma = 100;

        const widthAprobo = 100;

        const xFirma = 5;

        const xAprobo = 111;


        // ----------------------------------------------------------
        // FIRMA DEL CONDUCTOR
        // ----------------------------------------------------------

        if (
          cedulaConductor &&
          this.administraciones?.length > 0
        ) {

          const firmaPath =
            `${this.administraciones[0].nit}/personas/${cedulaConductor}/FIRMA_${cedulaConductor}.png`;


          try {

            const respuestaFirma =
              await firstValueFrom(
                this.gpcGoogle.getSignedUrl(
                  firmaPath
                )
              );


            if (
              respuestaFirma?.url
            ) {

              try {

                const firmaBase64 =
                  await this.gpcGoogle.getImageBase64(
                    respuestaFirma.url
                  );


                if (firmaBase64) {

                  doc.addImage(
                    firmaBase64,
                    'PNG',
                    xFirma,
                    y - 24,
                    90,
                    30,
                    undefined,
                    'FAST'
                  );
                }

              } catch (errorFirma) {

                console.warn(
                  'No se pudo cargar la firma:',
                  errorFirma
                );
              }
            }

          } catch (error) {

            console.warn(
              'Sin firma del conductor'
            );
          }
        }


        // ----------------------------------------------------------
        // NOMBRE
        // ----------------------------------------------------------

        doc.setFont(
          'helvetica',
          'normal'
        );

        doc.setFontSize(9);

        doc.setTextColor(0);

        doc.setDrawColor(0);


        doc.rect(
          xFirma,
          y,
          widthFirma,
          height
        );


        doc.text(
          nombreConductor
            .toUpperCase(),
          xFirma +
          widthFirma / 2,
          y + 7,
          {
            align: 'center'
          }
        );


        // ----------------------------------------------------------
        // REALIZÓ
        // ----------------------------------------------------------

        doc.rect(
          xFirma,
          y + height,
          widthFirma,
          height
        );


        doc.text(
          'REALIZO',
          xFirma +
          widthFirma / 2,
          y + height + 7,
          {
            align: 'center'
          }
        );


        // ----------------------------------------------------------
        // APROBÓ
        // ----------------------------------------------------------

        doc.rect(
          xAprobo,
          y + height,
          widthAprobo,
          height
        );


        doc.text(
          'APROBÓ',
          xAprobo +
          widthAprobo / 2,
          y + height + 7,
          {
            align: 'center'
          }
        );
      };


      const nombreConductor =
        `${this.resultadoPreo.conductor || ''}`
          .trim();


      const cedulaConductor =
        this.resultadoPreo.cedula || '';


      await renderFirmas(
        yPos + 35,
        nombreConductor,
        cedulaConductor
      );
      this.adminSeafLoadingService.actualizarPaso(
        'documentos',
        { estado: 'completado' },
        'Tablas, evaluaciones y firmas generadas'
      );

      this.adminSeafLoadingService.actualizarPaso(
        'evidencias',
        { estado: 'cargando' },
        'Consultando y procesando fotografías'
      );

      // ============================================================
      // 17. EVIDENCIAS FOTOGRÁFICAS
      // ============================================================

      const ruta =
        `${this.administraciones[0].nit}/alistamientos/${this.resultadoPreo.placa}/${this.resultadoPreo.id}`;


      let respuestaArchivos: any = null;


      try {

        respuestaArchivos =
          await firstValueFrom(
            this.gpcGoogle.listarArchivosPorRuta(
              ruta
            )
          );

      } catch (error) {

        console.warn(
          'No fue posible obtener evidencias:',
          error
        );
      }


      const archivos =
        respuestaArchivos?.archivos || [];


      const imagenes =
        archivos.filter(
          (archivo: any) =>
            archivo.contentType?.startsWith(
              'image/'
            )
        );




      // ============================================================
      // SI HAY EVIDENCIAS
      // ============================================================

      if (
        imagenes.length > 0
      ) {

        const pageWidth =
          doc.internal.pageSize.getWidth();


        const imagenWidth = 82;

        const imagenHeight = 46;


        const posicionesX = [
          15,
          113
        ];


        const posicionesY = [
          48,
          123,
          198
        ];


        const agregarEncabezadoEvidencias =
          () => {

            doc.setFontSize(14);

            doc.setFont(
              'helvetica',
              'bold'
            );

            doc.setTextColor(
              0,
              0,
              0
            );


            doc.text(
              'EVIDENCIAS FOTOGRÁFICAS',
              pageWidth / 2,
              18,
              {
                align: 'center'
              }
            );


            doc.setDrawColor(
              180,
              180,
              180
            );

            doc.setLineWidth(
              0.4
            );


            doc.line(
              15,
              23,
              pageWidth - 15,
              23
            );


            doc.setFontSize(9);

            doc.setFont(
              'helvetica',
              'normal'
            );

            doc.setTextColor(
              60,
              60,
              60
            );


            doc.text(
              `ID Alistamiento: ${this.resultadoPreo.id}`,
              15,
              31
            );


            doc.text(
              `Placa: ${this.resultadoPreo.placa || ''
              }`,
              pageWidth - 15,
              31,
              {
                align: 'right'
              }
            );
          };


        // ----------------------------------------------------------
        // PRIMERA PÁGINA DE EVIDENCIAS
        // ----------------------------------------------------------

        doc.addPage();

        agregarEncabezadoEvidencias();


        // ----------------------------------------------------------
        // RECORRER IMÁGENES
        // ----------------------------------------------------------

        for (
          let index = 0;
          index < imagenes.length;
          index++
        ) {

          const archivo =
            imagenes[index];


          // --------------------------------------------------------
          // NUEVA PÁGINA CADA 6
          // --------------------------------------------------------

          if (
            index > 0 &&
            index % 6 === 0
          ) {

            doc.addPage();

            agregarEncabezadoEvidencias();
          }


          const posicion =
            index % 6;


          const columna =
            posicion % 2;


          const fila =
            Math.floor(
              posicion / 2
            );


          const x =
            posicionesX[columna];


          const y =
            posicionesY[fila];


          try {

            console.log(
              'Cargando evidencia:',
              archivo.name
            );


            const imageData =
              await this.urlToDataUrl(
                archivo.url
              );


            const nombre =
              this.obtenerNombreEvidencia(
                archivo.name
              );


            // ------------------------------------------------------
            // TARJETA
            // ------------------------------------------------------

            const cardX =
              x - 3;


            const cardY =
              y - 10;


            const cardWidth =
              imagenWidth + 6;


            const cardHeight =
              imagenHeight + 23;


            doc.setFillColor(
              248,
              248,
              248
            );


            doc.setDrawColor(
              210,
              210,
              210
            );


            doc.setLineWidth(
              0.3
            );


            doc.roundedRect(
              cardX,
              cardY,
              cardWidth,
              cardHeight,
              2,
              2,
              'FD'
            );


            // ------------------------------------------------------
            // NOMBRE
            // ------------------------------------------------------

            doc.setFontSize(8);

            doc.setFont(
              'helvetica',
              'bold'
            );

            doc.setTextColor(
              35,
              35,
              35
            );


            const nombreLineas =
              doc.splitTextToSize(
                nombre,
                imagenWidth - 4
              );


            doc.text(
              nombreLineas.slice(0, 2),
              x +
              imagenWidth / 2,
              y - 3,
              {
                align: 'center'
              }
            );


            // ------------------------------------------------------
            // IMAGEN
            // ------------------------------------------------------

            /*
             * urlToDataUrl() convierte siempre la imagen
             * a JPEG, por eso aquí utilizamos JPEG.
             */

            doc.addImage(
              imageData,
              'JPEG',
              x,
              y,
              imagenWidth,
              imagenHeight
            );


            // ------------------------------------------------------
            // BORDE
            // ------------------------------------------------------

            doc.setDrawColor(
              170,
              170,
              170
            );


            doc.rect(
              x,
              y,
              imagenWidth,
              imagenHeight
            );


            // ------------------------------------------------------
            // FECHA
            // ------------------------------------------------------

            doc.setFontSize(
              6.5
            );


            doc.setFont(
              'helvetica',
              'normal'
            );


            doc.setTextColor(
              90,
              90,
              90
            );


            const fechaEvidencia =
              this.formatearFecha(
                archivo.updated
              );


            doc.text(
              fechaEvidencia,
              x +
              imagenWidth / 2,
              y +
              imagenHeight +
              7,
              {
                align: 'center'
              }
            );


            doc.setTextColor(
              0,
              0,
              0
            );


          } catch (error) {

            console.error(
              'Error agregando evidencia:',
              archivo.name,
              error
            );


            doc.setFontSize(8);

            doc.setFont(
              'helvetica',
              'normal'
            );

            doc.setTextColor(
              180,
              0,
              0
            );


            doc.text(
              'No se pudo cargar la imagen',
              x +
              imagenWidth / 2,
              y + 20,
              {
                align: 'center'
              }
            );


            doc.setTextColor(
              0,
              0,
              0
            );
          }
        }
      }


      // ============================================================
      // 18. FOOTER + QR TODAS LAS PÁGINAS
      // ============================================================

      const pageCount =
        doc.getNumberOfPages();


      for (
        let pagina = 1;
        pagina <= pageCount;
        pagina++
      ) {

        doc.setPage(
          pagina
        );


        this.addFooter(
          doc,
          pagina,
          pageCount
        );



      }


      // ============================================================
      // 19. FINALIZAR
      // ============================================================

      //this.mostrandoToast = false;

      this.adminSeafLoadingService.actualizarPaso(
        'evidencias',
        { estado: 'completado' },
        'Evidencias fotográficas procesadas'
      );


      const pdfBlob = doc.output('blob');
      const pdfUrl = URL.createObjectURL(pdfBlob);

      window.open(pdfUrl, '_blank');

      setTimeout(() => {
        URL.revokeObjectURL(pdfUrl);
      }, 60000);

      this.adminSeafLoadingService.actualizarPaso(
        'finalizar',
        { estado: 'completado' },
        'Preparando el documento para visualizarlo'
      );
      /*  console.log(
         'PDF generado correctamente.'
       );
    */

    } catch (error) {

      console.error(
        'Error al generar la ficha de alistamiento:',
        error
      );

      await Swal.fire({
        title: 'Error',
        text: 'No fue posible generar la ficha de alistamiento.',
        icon: 'error',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#be1e2d'
      });

    } finally {

      // Se ejecuta incluso si hay un error o un return.
      this.mostrandoToast = false;
      this.adminSeafLoadingService.ocultar();

    }




  }

  private obtenerNombreEvidencia(nombreArchivo: string): string {

    // Quitar extensión
    let nombre = nombreArchivo.replace(
      /\.[^/.]+$/,
      ''
    );

    // Quitar timestamp final
    nombre = nombre.replace(
      /_\d{10,}$/,
      ''
    );

    // Reemplazar guiones bajos
    nombre = nombre.replace(
      /_/g,
      ' '
    );

    // Mayúsculas
    return nombre.toUpperCase();
  }
  
  addHeaderHoja(doc: jsPDF) {
    const pageWidth = 280; // Ancho total en mm (Letter)
    const marginLeft = 10; // Margen izquierdo deseado
    const marginRight = 10; // Margen derecho igual para simetría
    const rectY = 3; // Distancia desde la parte superior
    const headerHeight = 15; // Altura del encabezado
    const rectWidth = pageWidth - marginLeft - marginRight;

    // Dibujar el rectángulo del encabezado
    doc.setDrawColor(0, 0, 0); // Borde negro
    doc.setLineWidth(0.5); // Grosor del borde
    doc.rect(marginLeft, rectY, rectWidth, headerHeight);

    // Título centrado dentro del rectángulo
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);

    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);

    doc.text(
      [
        "FORMATO DE INSPECCIÓN PREOPERACIONAL",
        "DE VEHÍCULOS Y EQUIPOS"
      ],
      105,
      12,
      { align: "center" }
    );
  }

  private urlToDataUrl(
    url: string
  ): Promise<string> {

    return new Promise(
      (resolve, reject) => {

        const img =
          new Image();

        img.crossOrigin =
          'anonymous';


        img.onload = () => {

          try {

            const canvas =
              document.createElement(
                'canvas'
              );

            canvas.width =
              img.naturalWidth;

            canvas.height =
              img.naturalHeight;


            const ctx =
              canvas.getContext(
                '2d'
              );


            if (!ctx) {

              reject(
                new Error(
                  'No se pudo obtener el contexto del canvas'
                )
              );

              return;
            }


            ctx.drawImage(
              img,
              0,
              0
            );


            // IMPORTANTE:
            // siempre devolvemos JPEG

            resolve(
              canvas.toDataURL(
                'image/jpeg',
                0.90
              )
            );

          } catch (error) {

            reject(error);
          }
        };


        img.onerror = () => {

          reject(
            new Error(
              'No se pudo cargar la imagen'
            )
          );
        };


        img.src = url;
      }
    );
  }
  addFooterHoja(doc: jsPDF, currentPage: number, totalPages: number) {
    const pageHeight = doc.internal.pageSize.height;
    const now = new Date();
    const fecha = now.toLocaleDateString("es-CO", {
      day: "numeric",
      month: "long",
      year: "numeric"
    });
    const hora = now.toLocaleTimeString("es-CO", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    });
    const fechaHora = `${fecha} - ${hora}`;

    doc.setFont("helvetica", "italic");
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);

    // Línea de pie centrada
    // Enlace clicable en el centro
    /*  const linkText = "Generado desde Admin SEAF – INDESOFT SAS";
     doc.textWithLink(linkText, 145, pageHeight - 6, {
       url: "https://indesoftsas.com",
       align: "center"
     }); */

    // Fecha y hora a la izquierda
    doc.text(
      `${fechaHora}` || "Generado desde Admin SEAF – INDESOFT SAS",
      10,
      pageHeight - 5
    );

    // Número de página a la derecha
    doc.text(
      `Página ${currentPage} de ${totalPages}`,
      270,
      pageHeight - 5,
      { align: "right" }
    );
  }


  async ExportarHoja() {


    const { placa, fecha, fechaFinal } = this.formPreoperacionales.value;
    if (!placa?.trim() || !fecha || !fechaFinal) {
      Swal.fire({
        title: "Campos requeridos",
        text: "Por favor, complete la placa y seleccione la fecha inicial y final.",
        icon: "info",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#3085d6",
      });
      return;
    }


    if (new Date(fecha) > new Date(fechaFinal)) {
      console.error("Fecha inicial no puede ser mayor que final");
      return;
    }

    this.mostrandoToast = true;
    const datos = { placa, fecha, fechaFinal };

    try {
      const response = await firstValueFrom(this.preoperacionalesService.getAlistamientoByPlacaHoja(datos));
      const registros = response?.preoperacional;

      if (!registros?.length) {
        this.mostrandoToast = false;
        Swal.fire({
          title: "Información",
          text: "Sin datos con los filtros seleccionados",
          icon: "info",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#3085d6",
        });
        return;
        return;
      }

      const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "letter" });

      const conceptos = [
        ["caja", "CAJA DE CAMBIOS / TRANSMISION"],
        ["suspension", "SUSPENSION / DIRECCION"],
        ["agua", "AGUA, ACEITE, COMBUS / FLUIDOS"],
        ["fugas", "FUGAS DEL MOTOR"],
        ["correas", "CORREAS"],
        ["electricos", "CONEXIONES ELECTRICAS"],
        ["espejo", "ESPEJO CENTRAL CONVEXO"],
        ["laterales", "ESPEJOS LATERALES"],
        ["alarma", "ALARMA DE RETROCESO Y PITO"],
        ["tapas", "TAPAS"],
        ["frenos", "FRENO DE SERVICIO"],
        ["frenoe", "FRENO DE EMERGENCIA"],
        ["vidrios", "VIDRIO FRONTAL / LIMPIABRISAS"],
        ["botiquin", "BOTIQUIN, EQUIPO DE CARRETERA"],
        ["extintor", "EXTINTOR DE INCENDIOS"],
        ["asientos", "ASIENTOS Y TAPICERIA"],
        ["tablero", "SENSORES TABLERO"],
        ["estribos", "ESTRIBOS"],
        ["baterias", "BATERIA, BORNES, CABLES"],
        ["altas", "EXTERIORES ALTAS Y BAJAS"],
        ["delanteras", "DIRECCIONALES DELANTERAS"],
        ["traseras", "DIRECCIONALES TRASERAS"],
        ["estacionarias", "LUCES DE ESTACIONAMIENTO"],
        ["stop", "LUCES DE STOP"],
        ["llantas", "ESTADO GRAL LLANTAS"],
        ["presion", "PRESION DEL AIRE"],
        ["repuesto", "LLANTA DE REPUESTOS"],
      ];

      const fechas = registros.map(r => r.fecha?.toString().slice(-2) || "--");

      const valoresPorConcepto: { [key: string]: string[] } = {};
      for (const [clave] of conceptos) {
        valoresPorConcepto[clave] = registros.map(r => {
          const val = r[clave]?.toUpperCase?.().trim();
          return val === "BUENO" ? "B" : val === "MALO" ? "M" : "N/A";
        });


      }

      this.addHeaderHoja(doc);
      await this.addHeaderImages(doc, this.gpcGoogle, {
        supertransporte: { path: "ministerio/supertransporte.png", x: 220, y: 4, w: 35, h: 12 },
        logo: { path: `${this.administraciones[0].nit}/logos/logo.png`, x: this.posicionX, y: this.posicionY, w: this.ancho, h: this.altura - 5 },
      }, "../../../../../assets/images/hoja_vida/sinfoto.png");

      // Fecha y hora actual en formato colombiano
      const ahora = new Date();
      const opciones: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
        timeZone: "America/Bogota",
      };
      const fechaHoraGenerada = new Intl.DateTimeFormat("es-CO", opciones).format(ahora);



      // Títulos principales
      doc.setFillColor(230, 230, 230);
      doc.setDrawColor(200);
      doc.roundedRect(10, 20, 260, 12, 0, 0, "FD");
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(40, 40, 40);
      doc.text(`PLACA: ${placa}`, 15, 27);
      doc.text(`FECHA INICIAL: ${this.formatearFecha(fecha)}`, 115, 27);
      doc.text(`FECHA FINAL: ${this.formatearFecha(fechaFinal)}`, 195, 27);

      // Encabezado de tabla
      const startY = 32;
      const cellHeight = 6;
      let x = 10;

      doc.setFontSize(8);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(0);

      // Cabecera de "CONCEPTO"
      doc.setFillColor(230, 230, 230); // Gris claro
      doc.rect(x, startY, 55, cellHeight, "FD");
      doc.text("CONCEPTO", x + 2, startY + 4);

      // Cabeceras de fechas
      fechas.forEach((f, i) => {
        const colX = x + 55 + i * 6;
        doc.setFillColor(230, 230, 230); // Gris claro
        doc.rect(colX, startY, 6, cellHeight, "FD");
        doc.text(f, colX + 1, startY + 4);
      });

      // Filas de conceptos y valores
      doc.setFont("helvetica", "normal");
      doc.setTextColor(0);

      conceptos.forEach(([clave, nombre], rowIndex) => {
        const y = startY + (rowIndex + 1) * cellHeight;

        // Celda concepto
        doc.setFillColor(255, 255, 255); // Blanco
        doc.rect(x, y, 55, cellHeight, "FD");
        doc.text(nombre, x + 2, y + 4);

        // Celdas valores por fecha
        valoresPorConcepto[clave].forEach((valor, colIndex) => {
          const colX = x + 55 + colIndex * 6;
          doc.setFillColor(255, 255, 255); // Blanco
          doc.rect(colX, y, 6, cellHeight, "FD");
          doc.text(valor, colX + 2, y + 4);
        });
      });

      const pageCount = doc.getNumberOfPages();

      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        this.addFooterHoja(doc, i, pageCount);

        // Mostrar PDF
        const blob = doc.output("blob");
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
      }
      this.mostrandoToast = false;
    } catch (error) {
      console.error("Error generando hoja consolidada:", error);
    }
  }

  async generarPDF(preoperacionales: preoperacionales) {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "letter",
    });

    const formatValue = (val: any): string =>
      val !== undefined && val !== null ? String(val) : "NO";

    this.addHeader(doc);

    await this.addHeaderImages(
      doc,
      this.gpcGoogle,
      {
        supertransporte: { path: "ministerio/supertransporte.png", x: 170, y: 7, w: 35, h: 12 },
        logo: { path: `${this.administraciones[0].nit}/logos/logo.png`, x: this.posicionX, y: this.posicionY, w: this.ancho, h: this.altura },
      },
      "../../../../../assets/images/hoja_vida/sinfoto.png"
    );

    const infoVehiculo = [
      ["ID:", String(preoperacionales.id)],
      ["FECHA Y HORA:", `${preoperacionales.fecha || ""} ${preoperacionales.hora || ""}`.trim()],
      ["PLACA Y INTERNO:", `${preoperacionales.placa || ""} - ${preoperacionales.vehicle?.interno || ""}`.trim()],
      ["KILOMETRAJE:", String(preoperacionales.kilometraje)],
      ["LICENCIA:", String(preoperacionales.vehicle?.matricula)],
      [
        "CONDUCTOR:",
        `${preoperacionales.propietario?.primernombre || ""} ${preoperacionales.propietario?.segundonombre || ""} ${preoperacionales.propietario?.papellidos || ""} ${preoperacionales.propietario?.seapellidos || ""}`.trim(),
      ],
    ];

    const drawDatosVehiculo = () => {
      const rowHeight = 7;
      const titleWidth = 35;
      const valueWidth = 68;
      const startX = 5;
      const startY = 37;

      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");

      for (let i = 0; i < infoVehiculo.length; i++) {
        const row = Math.floor(i / 2);
        const col = i % 2;
        const x = startX + col * (titleWidth + valueWidth);
        const y = startY + row * rowHeight;

        doc.setFillColor(75, 75, 75);
        doc.setDrawColor(200);
        doc.rect(x, y, titleWidth, rowHeight, "FD");
        doc.setTextColor(0);
        doc.setFont("helvetica", "bold");
        doc.text(infoVehiculo[i][0], x + 2, y + 5.5);

        doc.setFillColor(255, 255, 255);
        doc.rect(x + titleWidth, y, valueWidth, rowHeight, "FD");
        doc.setFont("helvetica", "normal");
        doc.setTextColor(0);
        doc.text(String(infoVehiculo[i][1]), x + titleWidth + 2, y + 5.5);
      }

      return startY + Math.ceil(infoVehiculo.length / 2) * rowHeight + 15;
    };

    const renderRevisionTecnica = (y: number, datos: any): number => {
      const elementos = [
        "caja", "suspension", "agua", "fugas", "correas", "electricos", "espejo", "laterales",
        "alarma", "tapas", "frenos", "frenoe", "cinturon", "vidrios", "botiquin", "extintor",
        "asientos", "tablero", "estribos", "baterias", "altas", "delanteras", "traseras",
        "estacionarias", "stop", "llantas", "presion", "repuesto"
      ];

      const etiquetas = new Map<string, string>([
        ["caja", "Caja de Cambios"],
        ["suspension", "Suspensión"],
        ["agua", "Sistema de Agua"],
        ["fugas", "Fugas"],
        ["correas", "Correas"],
        ["electricos", "Sistema Eléctrico"],
        ["espejo", "Espejos"],
        ["laterales", "Luces Laterales"],
        ["alarma", "Alarma Sonora"],
        ["tapas", "Tapas de Motor"],
        ["frenos", "Frenos Principales"],
        ["frenoe", "Freno de Emergencia"],
        ["cinturon", "Cinturón de Seguridad"],
        ["vidrios", "Vidrios y Ventanas"],
        ["botiquin", "Botiquín"],
        ["extintor", "Extintor"],
        ["asientos", "Asientos"],
        ["tablero", "Tablero de Instrumentos"],
        ["estribos", "Estribos"],
        ["baterias", "Baterías"],
        ["altas", "Luces Altas"],
        ["delanteras", "Luces Delanteras"],
        ["traseras", "Luces Traseras"],
        ["estacionarias", "Luces Estacionarias"],
        ["stop", "Luces de Stop"],
        ["llantas", "Llantas"],
        ["presion", "Presión de Llantas"],
        ["repuesto", "Llanta de Repuesto"]
      ]);

      const rowH = 7;
      const colCount = 2;
      const startX = 5;
      const colWidth = 100;

      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("RESULTADOS DE ALISTAMIENTO", startX, y);
      y += 4;

      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");

      for (let i = 0; i < elementos.length; i++) {
        const x = startX + (i % colCount) * colWidth;
        const yPos = y + Math.floor(i / colCount) * rowH;

        const key = elementos[i];
        const label = etiquetas.get(key) || key.toUpperCase();
        const value = formatValue(datos[key]);

        doc.setFillColor(240, 240, 240);
        doc.rect(x, yPos, 40, rowH, "FD");
        doc.setFont("helvetica", "bold");
        doc.text(label, x + 2, yPos + 5.5);

        doc.setFillColor(255, 255, 255);
        doc.rect(x + 40, yPos, 55, rowH, "FD");
        doc.setFont("helvetica", "normal");
        doc.text(value, x + 42, yPos + 5.5);
      }

      return y + Math.ceil(elementos.length / colCount) * rowH + 15;
    };

    const renderFirmasConductor = async (y: number, preoperacionales: preoperacionales): Promise<number> => {
      const height = 10;
      const widthFirma = 100;
      const widthAprobo = 100;

      const xFirma = 5;
      const xAprobo = 111;

      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.setTextColor(0);
      doc.setDrawColor(0);

      // Intentar cargar la firma del conductor
      const cedulaConductor = preoperacionales.cedula;
      if (cedulaConductor && this.administraciones.length > 0) {
        const firmaPath = `${this.administraciones[0].nit}/personas/FIRMA_${cedulaConductor}.png`;
        try {
          const firmaUrl = await this.gpcGoogle.getSignedUrl(firmaPath).toPromise();
          if (firmaUrl?.url) {
            try {
              const firmaBase64 = await this.gpcGoogle.getImageBase64(firmaUrl.url);
              if (firmaBase64) {
                doc.addImage(firmaBase64, "PNG", xFirma + 5, y - 12, 90, 15);
              }
            } catch (e) {
              console.log('No se pudo cargar la firma del conductor');
            }
          }
        } catch (e) {
          console.log('Firma del conductor no encontrada');
        }
      }

      // Nombre del conductor
      const nombreConductor = `${preoperacionales.propietario?.primernombre || ""} ${preoperacionales.propietario?.segundonombre || ""} ${preoperacionales.propietario?.papellidos || ""} ${preoperacionales.propietario?.seapellidos || ""}`.trim();

      doc.rect(xFirma, y, widthFirma, height);
      doc.text(nombreConductor.toUpperCase(), xFirma + widthFirma / 2, y + 7, {
        align: "center",
      });

      doc.setFont("helvetica", "normal");
      doc.rect(xFirma, y + height, widthFirma, height);
      doc.text("REALIZO", xFirma + widthFirma / 2, y + height + 7, {
        align: "center",
      });

      doc.setFont("helvetica", "normal");
      doc.rect(xAprobo, y + height, widthAprobo, height);
      doc.text("APROBÓ", xAprobo + widthAprobo / 2, y + height + 7, {
        align: "center",
      });

      return y + (height * 2) + 5;
    };

    let yPos = drawDatosVehiculo();
    yPos = renderRevisionTecnica(yPos + 10, preoperacionales);
    yPos = await renderFirmasConductor(yPos + 10, preoperacionales);


    // Mostrar en nueva pestaña
    const blob = doc.output("blob");
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  }

  limpiarFiltros(): void {
    this.formPreoperacionales.reset();
    this.minFechaFinal = ""; // Limpia la restricción si aplicas una mínima
  }

  //carga la funcion de listar los alistamientos realizado y no realizados
  onTabChange(event: any): void {
    this.tabActivo = event.nextId;

    // Oculta la tabla si es el tab 2
    this.mostrarTabla = this.tabActivo !== 2;

    if (this.tabActivo === 1) {
      this.cargarEstadoActual();
    }
  }

  cargarEstadoActual(): void {
    const fecha = this.formEstado.get('fechaEstado')?.value;

    if (!fecha) return;
    //console.log("incluirParticulares"+ this.incluirParticulares);
    this.preoperacionalesService.obtenerEstadoPorFecha(fecha, this.incluirParticulares).subscribe({
      next: (resp: any) => {
        this.estadoPreoperacional = resp.data;
        this.resultadosPreoperacionales = resp.data;

        // Ordenar por estado: REALIZADO primero, luego NO REALIZADO
        const dataOrdenada = [...resp.data].sort((a, b) => {
          if (a.estado_preoperacional === 'REALIZADO' && b.estado_preoperacional === 'NO REALIZADO') {
            return -1; // a va primero
          }
          if (a.estado_preoperacional === 'NO REALIZADO' && b.estado_preoperacional === 'REALIZADO') {
            return 1; // b va primero
          }
          return 0; // mantener orden original
        });

        this.filteredTableItems = dataOrdenada;

        // Para el gráfico
        const realizados = resp.resumen.realizados;
        const noRealizados = resp.resumen.no_realizados;

        this.chartSeries = [realizados, noRealizados];
        this.generarDatosGrafico();
      },
      error: (err) => {
        console.error('Error al obtener estado:', err);
        this.estadoPreoperacional = [];
        this.resultadosPreoperacionales = [];
        this.filteredTableItems = [];
      }
    });

  }


  formatearFecha(fechaISO: string): string {
    const fecha = new Date(fechaISO);
    const dia = String(fecha.getDate()).padStart(2, '0');
    const mes = String(fecha.getMonth() + 1).padStart(2, '0');
    const anio = fecha.getFullYear();
    return `${dia}/${mes}/${anio}`;
  }

  sortData(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.filteredTableItems = this.sortArray(this.filteredTableItems);
  }

  sortArray(array: any[]): any[] {
    return array.sort((a, b) => {
      const valueA = this.getFieldValue(a, this.sortColumn);
      const valueB = this.getFieldValue(b, this.sortColumn);

      if (valueA == null && valueB == null) return 0;
      if (valueA == null) return this.sortDirection === 'asc' ? -1 : 1;
      if (valueB == null) return this.sortDirection === 'asc' ? 1 : -1;

      if (typeof valueA === 'string') {
        return this.sortDirection === 'asc'
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      } else {
        return this.sortDirection === 'asc'
          ? valueA - valueB
          : valueB - valueA;
      }
    });
  }

  getFieldValue(item: any, field: string): any {
    switch (field) {
      case 'placa':
        return item.placa;
      case 'estado_preoperacional':
        return item.estado_preoperacional;
      // Agrega más campos aquí según tu estructura
      default:
        return item[field];
    }
  }

  sortData2(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.filteredPreoperacionales = this.sortArray(this.filteredPreoperacionales);
  }

  sortArray2(array: any[]): any[] {
    return array.slice().sort((a, b) => {
      const valueA = this.getValue(a, this.sortColumn);
      const valueB = this.getValue(b, this.sortColumn);

      if (valueA == null) return this.sortDirection === 'asc' ? -1 : 1;
      if (valueB == null) return this.sortDirection === 'asc' ? 1 : -1;

      if (typeof valueA === 'string') {
        return this.sortDirection === 'asc'
          ? valueA.localeCompare(valueB)
          : valueB.localeCompare(valueA);
      }

      return this.sortDirection === 'asc'
        ? valueA - valueB
        : valueB - valueA;
    });
  }

  getValue(item: any, column: string): any {
    switch (column) {
      case 'fecha':
        return new Date(item.fecha);
      case 'placa':
        return item.placa;
      case 'kilometraje':
        return item.kilometraje;
      case 'cedula':
        return item.cedula;
      case 'conductor':
        return `${item.propietario?.primernombre ?? ''} ${item.propietario?.papellidos ?? ''}`.trim();
      default:
        return item[column];
    }
  }

  private cargarDataAdmin(): void {
    this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {
        //   console.log(data);
        this.administraciones = data;
        this.altura = data[0].dimensionLogo.h;      // "8"
        this.ancho = data[0].dimensionLogo.w;       // "40"
        this.posicionX = data[0].dimensionLogo.x;   // 10
        this.posicionY = data[0].dimensionLogo.y;
        this.incluirParticulares = data[0].incluirParticulares;
        //console.log("incluirParticulares "+ this.incluirParticulares)
        this.cargarEstadoActual();
      },
      error: (err) => {
        console.error("Error al cargar los conductores:", err);
      },
    });
  }

  async informepesv(): Promise<void> {
    const { fecha, fechaFinal } = this.formPreoperacionales.value;
    // console.log("Fechas seleccionadas:", { fecha, fechaFinal });
    if (!fecha || !fechaFinal) {
      Swal.fire({
        title: "Campos requeridos",
        text: "Por favor, seleccione la fecha inicial y final.",
        icon: "info",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#3085d6",
      });
      return;
    }

    Swal.fire({
      title: 'Generando Informe PESV',
      html: 'Por favor espere...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    this.preoperacionalesService.informePesv({ fecha, fechaFinal }).subscribe({
      next: (blob) => {
        Swal.close();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Informe_PESV_${fecha}_${fechaFinal}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);
        Swal.fire({
          title: 'Éxito',
          text: 'Informe PESV descargado correctamente',
          icon: 'success',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#3085d6'
        });
      },
      error: (err) => {
        Swal.close();
        console.error("Error al obtener informe PESV:", err);
        Swal.fire('Error', err.message || 'No se pudo generar el informe PESV', 'error');
      },
    });
  }

  async informeTrimestralPesv(): Promise<void> {
    Swal.fire({
      title: 'Generando Informe Trimestral PESV',
      html: 'Por favor espere...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const fechaActual = new Date().toISOString().split('T')[0];

    this.preoperacionalesService.informeTrimestralPesv().subscribe({
      next: (blob) => {
        Swal.close();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Informe_Trimestral_PESV_${fechaActual}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);
        Swal.fire({
          title: 'Éxito',
          text: 'Informe Trimestral PESV descargado correctamente',
          icon: 'success',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#3085d6'
        });
      },
      error: (err) => {
        Swal.close();
        console.error("Error al obtener informe trimestral PESV:", err);
        Swal.fire('Error', err.message || 'No se pudo generar el informe trimestral PESV', 'error');
      },
    });
  }

}
